import { roundDecimalHalfUp } from './money';

// Mirrors backend/src/utils/warehouseQuantity.js. Keep commercial precision,
// rounding and public WZ limits aligned across both runtimes.
export const WAREHOUSE_QUANTITY_PRECISION = 3;
export const WAREHOUSE_QUANTITY_MIN = 0.001;
export const WZ_QUANTITY_MAX = 1000000;
// Mirrors PZ_LIMITS.maxQuantity in backend/src/services/pzService.js. PZ accepts
// a larger receipt than a WZ release; do not tighten it here or the form rejects
// payloads the server would have taken.
export const PZ_QUANTITY_MAX = 100000000;
export const WZ_QUANTITY_INVALID_CODE = 'WZ_QUANTITY_INVALID';
// Only absorb binary floating-point noise. A commercial fourth decimal must
// never pass validation and then be rounded silently by NUMERIC(14,3).
const WAREHOUSE_QUANTITY_EPSILON = 1e-9;

// The one half-up of money and quantities (money.ts roundDecimalHalfUp).
export function roundWarehouseQuantity(value: unknown): number {
  return roundDecimalHalfUp(value, WAREHOUSE_QUANTITY_PRECISION);
}

export function isWarehouseQuantity(value: unknown, min = WAREHOUSE_QUANTITY_MIN): boolean {
  const quantity = Number(value);
  return Number.isFinite(quantity)
    && quantity >= min
    && Math.abs(quantity - roundWarehouseQuantity(quantity)) < WAREHOUSE_QUANTITY_EPSILON;
}
